import { computed } from 'vue';

import { useMobileDetection } from './useMobileDetection';

const VITE_ENV_NAME = import.meta.env.VITE_ENV_NAME;

export const useHeaderHeight = () => {
  const isMobile = useMobileDetection(991);

  const heightPx = computed(() => {
    if (isMobile.value) {
      let height = 85;
      if (VITE_ENV_NAME === 'PROD') {
        height = height - 21;
      }
      return `${height}px`;
    } else {
      let height = 117;
      if (VITE_ENV_NAME === 'PROD') {
        height = height - 21;
      }
      return `${height}px`;
    }
  });

  return heightPx;
};
